import * as React from "react";
import { connect } from "react-redux";
import config from "../../config";
import { style } from "typestyle";

const css = {
  center: style({
    textAlign: "center",
    fontSize: "2em",
    fontWeight: "bold",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "100%",
  }),
};

class RedirectToQCApp extends React.Component<any, {}> {
  public componentDidMount() {
    const customerId = this.props.customerId;
    const siteId = this.props.siteId;
    const scanDate = this.props.scanDate;
    setTimeout(() => {
      this.redirectToQCApp(customerId, siteId, scanDate);
    }, 3000);
  }

  public render() {
    return (
      <div className={css.center}>Redirecting to QC-App after 3 sec...</div>
    );
  }

  private redirectToQCApp(
    customerId: string,
    siteId: string,
    scanDate: string,
  ) {
    window.location.href = `${config.endpoints.qcApp}/${customerId}/${siteId}/${scanDate}`;
  }
}

export default connect((state: any) => ({}))(RedirectToQCApp);
